import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useAccountingMode } from '../contexts/AccountingModeContext';
import { Button } from './ui/button';
import { LogOut, Lock, Eye } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import logo from '../assets/agrabat_logo.png';

const Header = () => {
  const { user, logout } = useAuth();
  const { mode, toggleMode, isDeclaredMode, isTotalMode } = useAccountingMode();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    toast.success('Déconnexion réussie');
    navigate('/login');
  };

  return (
    <header className="h-16 bg-white border-b border-slate-200 px-6 flex items-center justify-between shadow-sm" data-testid="header">
      <div className="flex items-center gap-4">
        <img src={logo} alt="AGRABAT" className="h-10 object-contain" />
      </div>

      <div className="flex items-center gap-4">
        {/* Accounting Mode Toggle - Admin Only */}
        {user?.role === 'admin' && (
          <div className="flex items-center gap-2 px-4 py-2 bg-slate-50 rounded-sm border border-slate-200">
            <span className="text-sm font-medium text-slate-700">Vue:</span>
            <Button
              onClick={toggleMode}
              variant="outline"
              size="sm"
              data-testid="accounting-mode-toggle"
              className={`h-8 font-medium rounded-sm transition-all ${
                isDeclaredMode
                  ? 'bg-[#1B3268] text-white hover:bg-[#152a55] border-[#1B3268]'
                  : 'bg-[#FDC800] text-[#1B3268] hover:bg-[#e6b600] border-[#FDC800]'
              }`}
            >
              {isDeclaredMode ? (
                <>
                  <Eye className="w-4 h-4 mr-1" />
                  Déclarée (A)
                </>
              ) : (
                <>
                  <Lock className="w-4 h-4 mr-1" />
                  Totale (A+B)
                </>
              )}
            </Button>
          </div>
        )}

        {!user?.role || user.role === 'user' ? (
          <div className="px-4 py-2 bg-slate-100 rounded-sm border border-slate-200">
            <span className="text-sm font-medium text-[#1B3268] flex items-center gap-2">
              <Eye className="w-4 h-4" />
              Vue Déclarée (A)
            </span>
          </div>
        ) : null}

        <Button
          onClick={handleLogout}
          variant="ghost"
          size="sm"
          data-testid="logout-button"
          className="hover:bg-slate-100 text-slate-700 font-medium rounded-sm"
        >
          <LogOut className="w-4 h-4 mr-2" />
          Déconnexion
        </Button>
      </div>
    </header>
  );
};

export default Header;
